import { LogWarning } from "./logger"

// Staff Role Constants
export const INACTIVE_USER_ROLE = -1
export const SYSTEM_ADMIN_ROLE = 0
export const APP_MANAGER_ROLE = 1
export const ENTERPRISE_ADMIN_ROLE = 2
export const ORGANIZATION_ADMIN_ROLE = 3
export const ORGANIZATION_SUPERVISOR_ROLE = 4
export const ORGANIZATION_STAFF_ROLE = 6
export const ORGANIZATION_VOLUNTEER_ROLE = 7
export const PARTNER_ADMIN_ROLE = 9
export const AUTHENTICATED_PARTNER_USER_ROLE = 10
export const AUTHENTICATED_USER_ROLE = 100
// Source: https://team-1607816385495.atlassian.net/wiki/spaces/DEV/pages/1995112455/SOAR+User+Roles

function validateStaffRole(staff_role) {
  if (!Number.isInteger(staff_role)) {
    LogWarning(`Invalid staff_role provided: ${staff_role}`)
    return false
  }
  return true
}

export function isSystemAdmin(staff_role) {
  return isRole(staff_role, SYSTEM_ADMIN_ROLE)
}

export function isAppManager(staff_role, orAbove) {
  return isRole(staff_role, APP_MANAGER_ROLE, orAbove)
}

export function isEnterpriseAdmin(staff_role, orAbove) {
  return isRole(staff_role, ENTERPRISE_ADMIN_ROLE, orAbove)
}

export function isOrganizationAdmin(staff_role, orAbove) {
  return isRole(staff_role, ORGANIZATION_ADMIN_ROLE, orAbove)
}

export function isOrganizationSupervisor(staff_role, orAbove) {
  return isRole(staff_role, ORGANIZATION_SUPERVISOR_ROLE, orAbove)
}

export function isOrganizationStaff(staff_role, orAbove) {
  return isRole(staff_role, ORGANIZATION_STAFF_ROLE, orAbove)
}

export function isOrganizationVolunteer(staff_role) {
  return isRole(staff_role, ORGANIZATION_VOLUNTEER_ROLE)
}

export function isInactiveUser(staff_role) {
  if (!validateStaffRole(staff_role)) return false
  return staff_role === INACTIVE_USER_ROLE
}

export function isPartnerAdmin(staff_role) {
  if (!validateStaffRole(staff_role)) return false
  return staff_role === PARTNER_ADMIN_ROLE
}

function isRole(staff_role, role, orAbove) {
  if (!validateStaffRole(staff_role)) return false
  return orAbove
    ? staff_role <= role && staff_role !== INACTIVE_USER_ROLE
    : staff_role === role
}
